// extracted by mini-css-extract-plugin
export default {"loader":"KWPgLRP9Ip6nE9gUSXGy","backButton":"A_7q6Alax6Cvg2JW2AEs","pulse":"A27f_Lbu9FMe008fznTJ"};